import { render, staticRenderFns } from "./fileSelector.vue?vue&type=template&id=27e21dfb&scoped=true&"
import script from "./fileSelector.vue?vue&type=script&lang=js&"
export * from "./fileSelector.vue?vue&type=script&lang=js&"
import style0 from "./fileSelector.vue?vue&type=style&index=0&id=27e21dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e21dfb",
  null
  
)

export default component.exports